<template lang="pug">
.balance-bar(v-if='$permission.has("bills.balance")')
  template(v-if='balance.from && balance.lastTotal')
    .title 起始日期
    .value {{$formatters.date.to_date(balance.from)}}
    .title 起始结余
    .value(:class='{negative: balance.lastTotal < 0}') {{$formatters.money(balance.lastTotal)}}
    .value |
  .title 截至日期
  .value {{$formatters.date.to_date(balance.to)}}
  .title 收入
  .value(:class='{negative: balance.income < 0}') {{$formatters.money(balance.income)}}
  .title 支出
  .value(:class='{negative: balance.outcome > 0}') {{$formatters.money(-balance.outcome)}}
  template(v-if='balance.from && balance.lastTotal')
    .title 合计
    .value(:class='{negative: balance.total < 0}') {{$formatters.money(balance.total)}}
    .value |
    .title 结余
    .value(:class='{negative: balance.total + balance.lastTotal < 0}') {{$formatters.money(balance.total + balance.lastTotal)}}
  template(v-else)
    .title 结余
    .value(:class='{negative: balance.total < 0}') {{$formatters.money(balance.total)}}
</template>

<script>
export default {
  props: {
    date: Object,
    from: Object,
    state: {
      type: String,
      default: 'all',
    },
  },
  data() {
    return {
      balance: {
        income: 0,
        total: 0,
        outcome: 0,
      },
    }
  },
  watch: {
    date() {
      this.load_balance()
    },
    from() {
      this.load_balance()
    },
    state() {
      this.load_balance()
    },
  },
  mounted() {
    this.load_balance()
  },
  methods: {
    load_balance() {
      this.$http.get('report/balance', { params: {
        to: this.$moment(this.date).toISOString(),
        from: this.from ? this.$moment(this.from).toISOString() : undefined,
        state: this.state === 'all' ? undefined : this.state,
      } })
        .then(r => {
          this.balance = r.body
        })
        .catch((...args) => {
          this.$utils.DefaultErrorHandler.call(this, ...args)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// BalanceBar.vue?52ec2351